import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Tabs, Tab } from "react-bootstrap";
import PropTypes from "prop-types";
import SimpleReactValidator from "simple-react-validator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Spinner from "components/common/Spinner";
import {
    openCustomModal,
    closeCustomModal
} from "components/custom/modals";

import FromServices from "components/menu/email-blaster/from-services";
import FromDirectory from "components/menu/email-blaster/from-directory";
import {
    requestGetScheduleEmails
} from "api/menu/schedule/actions";
import {
    sendEmail
} from "api/menu/email-blaster/actions";


import JoditEditor from "jodit-react";

class EmailBlaster extends React.Component {
    tabs = {
        services: "From Services",
        directory: "From Directory"
    };

    modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{
                list: "ordered"
            }, {
                list: "bullet"
            }, {
                indent: "-1"
            }, {
                indent: "+1"
            }],
            ["link", "image"],
            ["clean"]
        ],
    };

    formats = [
        "header",
        "bold", "italic", "underline", "strike", "blockquote",
        "list", "bullet", "indent",
        "link", "image"
    ];

    constructor(props) {
        super(props);

        this.fromServices = React.createRef();
        this.fromDirectory = React.createRef();
        this.attachRef = React.createRef();

        this.state = {
            loading: this.props.isModal,
            activeTab: this.tabs.services,

            emailTo: "",
            emailCc: "",
            emailBcc: "",
            files: null,
            subject: "",
            body: ""
        };

        this.setLoading = this.setLoading.bind(this);
        this.handleChangeEmailList = this.handleChangeEmailList.bind(this);
        this.handleAttachment = this.handleAttachment.bind(this);
        this.removeAttachment = this.removeAttachment.bind(this);
        this.handleChangeMessage = this.handleChangeMessage.bind(this);
        this.handleChangeTab = this.handleChangeTab.bind(this);
        this.handleAddEmails = this.handleAddEmails.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.uniqBy = this.uniqBy.bind(this);

        this.validator = new SimpleReactValidator({
            locale: "en",
            element: message => <div className="text-danger">{message}</div>
        });

        if (this.props.isModal) {
            this.props.requestGetScheduleEmails(this.props.requestData, (data) => {
                const newStates = {
                    loading: false
                };
                if (data) {
                    if (data.userEmail) {
                        newStates.emailTo = data.userEmail;
                    }
                    if (data.supervisorsEmails) {
                        const supervisorsEmails =
                            Array.isArray(data.supervisorsEmails)
                                ? data.supervisorsEmails
                                : [];
                        newStates.emailCc = supervisorsEmails.join("; ");
                        /*
                        const accountManagersEmails =
                            Array.isArray(data.accountManagersEmails)
                                ? data.accountManagersEmails
                                : [];
                        newStates.emailCc = supervisorsEmails.concat(accountManagersEmails).join("; ");
                        */
                    }
                    if (data.merchandisersEmails) {
                        newStates.emailBcc = data.merchandisersEmails.join("; ");
                    }
                }
                this.setState(newStates);
            });
        }
    }

    setLoading = (status) => {
        this.setState({
            loading: status
        });
    };

    handleChangeEmailList = (name, value) => {
        this.setState({
            [name]: value
        });
    };

    handleAttachment = (ev) => {
        const {
            name,
            files
        } = ev.target;
        let newFiles = Array.from(files);
        const filesInState = this.state[name];
        if (filesInState) {
            newFiles = newFiles.concat(filesInState);
        }
        newFiles = this.uniqBy(newFiles, it => it.name);

        this.setState({
            [name]: newFiles
        });
        // https://gist.github.com/alexandrebodin/d69fc465fb731b665429f6da472929df
    };

    removeAttachment = (item) => {
        const newFiles = this.state.files;

        const index = newFiles.findIndex(x => x.name === item.name);

        newFiles.splice(index, 1);

        this.setState({
            files: newFiles
        });
    };

    uniqBy = (a, key) => {
        const seen = new Set();
        return a.filter(item => {
            const k = key(item);
            return seen.has(k) ? false : seen.add(k);
        });
    };

    handleChangeMessage = (name, value) => {
        this.setState({
            [name]: value
        });
    };

    handleChangeTab = (key) => {
        this.setState({
            activeTab: key
        });
    };

    handleAddEmails = (name) => {
        let users = [];
        if (this.state.activeTab === this.tabs.services) {
            users = this.fromServices.getSelectedUsersEmail();
        } else if (this.state.activeTab === this.tabs.directory) {
            if (this.fromDirectory) {
                users = this.fromDirectory.getSelectedUsersEmail();
            }
        }

        const newEmailString = users.join("; ");
        if (newEmailString !== "") {
            let currentValue = this.state[name];
            currentValue += currentValue !== "" ? `; ${newEmailString}` : newEmailString;
            this.setState({
                [name]: currentValue
            });
        }
    };

    handleSend = () => {
        const {
            emailTo,
            emailCc,
            emailBcc,
            files,
            subject,
            body
        } = this.state;

        if (this.validator.allValid()) {
            this.props.sendEmail({
                To: emailTo,
                Cc: emailCc,
                Bcc: emailBcc,
                Subject: subject,
                Body: body,
                files
            }, () => {
                if (this.props.isModal && this.props.onCancel) {
                    this.props.onCancel();
                }
                this.setState({
                    emailTo: "",
                    emailCc: "",
                    emailBcc: "",
                    files: null,
                    subject: "",
                    body: ""
                });
                this.attachRef.current.value = null;
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }


    };

    render() {
        const {
            emailTo,
            emailCc,
            emailBcc,
            subject,
            body
        } = this.state;

        return (
            <div className="position-relative">
                {!this.props.loading || <Spinner/>}
                <div className="row p-2">
                    <div className="col-8">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text justify-content-end"
                                      style={{ width: 100 }}>To:</span>
                            </div>
                            <textarea
                                className="form-control"
                                name="emailTo"
                                onChange={(ev) => this.handleChangeEmailList("emailTo", ev.target.value)}
                                value={emailTo}
                                tabIndex={1}
                            />
                            <div className="input-group-append">
                                <button
                                    className="btn btn-success"
                                    onClick={() => this.handleAddEmails("emailTo")}
                                >
                                    <FontAwesomeIcon icon="arrow-left"/>
                                </button>
                            </div>
                        </div>

                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text justify-content-end"
                                      style={{ width: 100 }}>Cc:</span>
                            </div>
                            <textarea
                                className="form-control"
                                name="emailCc"
                                onChange={(ev) => this.handleChangeEmailList("emailCc", ev.target.value)}
                                value={emailCc}
                                tabIndex={2}
                            />
                            <div className="input-group-append">
                                <button
                                    className="btn btn-success"
                                    onClick={() => this.handleAddEmails("emailCc")}
                                >
                                    <FontAwesomeIcon icon="arrow-left"/>
                                </button>
                            </div>
                        </div>

                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text justify-content-end"
                                      style={{ width: 100 }}>Bcc:</span>
                            </div>
                            <textarea
                                className="form-control"
                                name="emailBcc"
                                onChange={(ev) => this.handleChangeEmailList("emailBcc", ev.target.value)}
                                value={emailBcc}
                                tabIndex={3}
                            />
                            <div className="input-group-append">
                                <button
                                    className="btn btn-success"
                                    onClick={() => this.handleAddEmails("emailBcc")}
                                >
                                    <FontAwesomeIcon icon="arrow-left"/>
                                </button>
                            </div>
                        </div>
                        {this.validator.message("emailTo", emailTo || emailCc || emailBcc, "required")}

                        <div className="input-group mt-3 mb-3">
                            <div className="input-group-prepend">
                            <span className="input-group-text justify-content-end"
                                  style={{ width: 100 }}>
                                Attachment:
                            </span>
                            </div>
                            <input
                                ref={this.attachRef}
                                type="file"
                                multiple={true}
                                className="form-control file-input pr-1"
                                name="files"
                                onChange={this.handleAttachment}
                                tabIndex={4}
                                style={{
                                    maxWidth: "106px",
                                    borderRight: "none"
                                }}
                            />
                            <ul style={{
                                borderLeft: "none",
                                display: "flex",
                                alignItems: "center",
                                overflow: "auto"
                            }} className="form-control input-group-append list-inline">
                                {
                                    // eslint-disable-next-line max-len
                                    Array.isArray(this.state.files) && this.state.files.map((item, key) => (
                                        <li
                                            key={key}
                                            style={{ border: "1px solid #ced4da" }}
                                            className="list-inline-item"
                                        >
                                                <span style={{
                                                    fontSize: "14px",
                                                    margin: "2px"
                                                }}>
                                                    {item.name}
                                                </span>
                                            <span onClick={() => this.removeAttachment(item)}>
                                                    <i
                                                        style={{
                                                            margin: "2px",
                                                            cursor: "pointer"
                                                        }}
                                                        className="fas fa-times"
                                                    />
                                                </span>
                                        </li>
                                    ))
                                }
                            </ul>
                        </div>
                        <div className="input-group">
                            <div className="input-group-prepend">
                            <span className="input-group-text justify-content-end"
                                  style={{ width: 100 }}>
                                Subject:
                            </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                name="subject"
                                onChange={(ev) => this.handleChangeMessage("subject", ev.target.value)}
                                value={subject}
                                tabIndex={5}
                            />
                        </div>
                        {this.validator.message("subject", subject, "required")}

                        <div className="mt-3">
                            <JoditEditor
                                tabIndex={1}
                                value={body}
                                onChange={content => this.setState({
                                    body: content
                                })}
                            />
                        </div>
                        {this.validator.message("body", body, "required")}

                        <div className="text-right mt-3 mb-3">
                            <button
                                className="btn btn-lg btn-success ml-3"
                                onClick={() => this.handleSend()}
                                tabIndex={8}
                            >
                                <FontAwesomeIcon icon="paper-plane"/> Send
                            </button>
                        </div>
                    </div>

                    <div className="col-4">
                        <Tabs
                            id="email-blaster-tabs"
                            defaultActiveKey={this.tabs.services}
                            className="w-100"
                            unmountOnExit={true}
                            onSelect={this.handleChangeTab}
                        >
                            <Tab
                                eventKey={this.tabs.services}
                                title="Services"
                            >
                                <FromServices
                                    ref={(connectedComponent) => {
                                        if (connectedComponent &&
                                            connectedComponent.wrappedInstance) {
                                            this.fromServices = connectedComponent.wrappedInstance;
                                        }
                                    }}
                                />
                            </Tab>
                            <Tab
                                eventKey={this.tabs.directory}
                                title="Directory"
                            >
                                <FromDirectory
                                    ref={(connectedComponent) => {
                                        if (connectedComponent &&
                                            connectedComponent.wrappedInstance) {
                                            this.fromDirectory = connectedComponent.wrappedInstance;
                                        }
                                    }}
                                />
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }
}

EmailBlaster.defaultProps = {
    requestData: {},
    isModal: false,
    onCancel: false
};

EmailBlaster.propTypes = {
    requestData: PropTypes.object.isRequired,
    isModal: PropTypes.bool.isRequired,
    onCancel: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]).isRequired,
};

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

    requestGetScheduleEmails: bindActionCreators(requestGetScheduleEmails, dispatch),
    sendEmail: bindActionCreators(sendEmail, dispatch),
});
const mapStateToProps = state => ({
    loading: state.emailBlaster.loading,
});

export default connect(
    mapStateToProps,
    mapStateToDispatch,
    null,
    { withRef: true }
)(EmailBlaster);
